<template>
  <v-card outlined>
    <table-search @search="v => (search = v)" />
    <v-data-table
      class="mt-5"
      dense
      fixed-header
      :headers="headers"
      :items="loadApprovalPins"
      item-key="id"
      :items-per-page="15"
      :sort-by="['createdAt']"
      :sort-desc="[true]"
      no-data-text="No Records Found!"
      no-results-text="No Records Found!"
      :search="search"
      :loading="pending"
      loading-text="Loading... Please wait"
    >
      <!-- <template v-slot:[`item.alive`]="{ item }">
        {{ item.alive ? 'Yes' : 'No' }}
      </template> -->
      <template v-slot:[`item.actions`]="{ item }">
        <row-actions :actions="{ delete: () => doDelete(item) }" />
      </template>
      <template v-slot:[`item.ttl`]="{ item }">
        {{ validUntil(item.createdAt, item.ttl) | moment('YYYY/MM/DD hh:mm:ss A') }}
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ item.createdAt | moment('YYYY/MM/DD hh:mm:ss A') }}
      </template>
      <template v-slot:[`item.updatedAt`]="{ item }">
        {{ item.updatedAt | moment('YYYY/MM/DD hh:mm:ss A') }}
      </template>
      <template v-slot:footer>
        <table-action :actions="{ add: () => toggleLoadApprovalPinForm('create') }" />
      </template>
    </v-data-table>
    <load-approval-pin-form />
  </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import loadApprovalPinHeaders from '@/models/load-approval-pins-headers';
import LoadApprovalPinForm from '@/components/load_approval/LoadApprovalPinForm';
import moment from 'moment';

export default {
  name: 'LoadApprovalPins',
  data() {
    return { search: '' };
  },
  computed: {
    ...mapState('loadApproval', ['loadApprovalPins', 'pending']),
    headers: () => loadApprovalPinHeaders
  },
  methods: {
    ...mapMutations('confirm', ['confirm']),
    ...mapMutations('loadApproval', ['toggleLoadApprovalPinForm', 'setLoadApprovalPin']),
    ...mapActions('loadApproval', [
      'createLoadApprovalPin',
      'updateLoadApprovalPin',
      'deleteLoadApprovalPin'
    ]),
    doEdit(p) {
      this.setLoadApprovalPin(p);
      this.toggleLoadApprovalPinForm('update');
    },
    doDelete(p) {
      this.confirm({
        message: 'Do you want to delete this PIN ?',
        iconColor: 'error',
        acceptAction: () => this.deleteLoadApprovalPin(p)
      });
    },
    validUntil(createdAt, vfminutes) {
      return moment(createdAt).add(vfminutes, 'minutes');
    }
  },
  components: { LoadApprovalPinForm }
};
</script>

<style lang="scss" scoped>
.table_search {
  width: 50%;
  @media (min-width: 340px) and (max-width: 767px) {
    width: 60%;
  }
}
</style>
